// extracted by mini-css-extract-plugin
export var logo = "_lv-2";
export var logoWrapper = "_lv-1";
export var strip = "_lv-0";